import { ArrowUpRight, CircleDot, DoorOpen, Eye, Gauge, Layers, Lock, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const icons = {
  Social: Users,
  Existential: CircleDot,
  Physical: Gauge,
  Control: Lock,
  Unknown: Eye,
  Isolation: Layers,
  Failure: ArrowUpRight,
  Loss: CircleDot
};

function FearCard({ fear }) {
  const Icon = icons[fear.category] || Eye;
  const rememberRoom = () => {
    sessionStorage.setItem("museum:lastFear", fear.slug);
  };

  return (
    <motion.article
      id={`fear-${fear.slug}`}
      layout
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 16 }}
      className="group scroll-mt-28 relative overflow-hidden rounded-lg soft-border bg-museum-panel/70 p-5 transition duration-300 hover:-translate-y-1 hover:border-museum-gold/50 hover:shadow-glow target:border-museum-gold/70 target:shadow-glow"
    >
      <div className="absolute inset-0 opacity-0 transition duration-500 group-hover:opacity-100">
        <div className="fog-layer" />
      </div>
      <div className="relative">
        <div className="mb-6 flex items-center justify-between gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full border border-museum-gold/25 bg-museum-black/55 text-museum-gold">
            <Icon size={22} aria-hidden="true" />
          </div>
          <span className="rounded-full border border-museum-bone/10 px-3 py-1 text-xs uppercase tracking-[0.2em] text-museum-muted">
            {fear.category}
          </span>
        </div>
        <h3 className="font-display text-2xl text-museum-bone">{fear.name}</h3>
        <p className="mt-3 text-sm leading-6 text-museum-gold/90">{fear.tagline}</p>
        <p className="mt-5 min-h-[4.5rem] text-sm leading-7 text-museum-muted">{fear.shortDescription}</p>
        <div className="mt-6 flex items-center justify-between border-t border-museum-bone/10 pt-5">
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-museum-muted">Intensity</p>
            <p className="mt-1 font-display text-2xl text-museum-bone">{fear.intensity}/10</p>
          </div>
          <Link
            to={`/fear/${fear.slug}`}
            onClick={rememberRoom}
            className="inline-flex items-center gap-2 rounded-full border border-museum-bone/15 px-4 py-2 text-sm text-museum-bone transition hover:border-museum-gold/60 hover:text-museum-gold"
          >
            <DoorOpen size={16} aria-hidden="true" />
            Enter Room
          </Link>
        </div>
      </div>
    </motion.article>
  );
}

export default FearCard;
